export interface AttachmentAttributeModel {
  attributeName: string;
  mimeType: string | null;
  maxAttachmentSize: number | null;
}
